import type { AppLanguage } from '@/shared/i18n/types';

import enFile from './en.json';
import jaFile from './ja.json';

// 取出命名空间数据
const ja = (jaFile as { wallet: any }).wallet;
const en = (enFile as { wallet: any }).wallet;

export const walletNamespaceResources: Record<AppLanguage, any> = {
  ja,
  en,
};

